<template>
    <JetFormSection @submitted="updateSettingTarifNilaiTutam">
        <template #title> Tarif Nilai Tutam </template>

        <template #description> Setting tarif nilai tutam </template>

        <template #form>
            <div class="col-span-6 sm:col-span-4">
                <JetLabel for="tarif_nilai_tutam" value="Tarif Nilai Tutam" />
                <JetInput
                    id="tarif_nilai_tutam"
                    type="text"
                    class="mt-1 block w-full"
                    v-model="form.tarif_nilai_tutam"
                    autocomplete="tarif_nilai_tutam"
                />
                <JetInputError
                    :message="form.errors.tarif_nilai_tutam"
                    class="mt-2"
                />
            </div>
        </template>

        <template #actions>
            <InertiaButtonSave
                :class="{ 'opacity-25': form.processing }"
                label="Simpan Tarif"
            />
        </template>
    </JetFormSection>
</template>

<script>
import { defineComponent } from "vue";
import JetFormSection from "@/Jetstream/FormSection";
import JetInput from "@/Jetstream/Input";
import JetInputError from "@/Jetstream/InputError";
import JetLabel from "@/Jetstream/Label";
import InertiaButtonSave from "@/Components/InertiaButtonSave.vue";

export default defineComponent({
    components: {
        JetFormSection,
        JetInput,
        JetInputError,
        JetLabel,
        InertiaButtonSave,
    },
    data() {
        return {
            form: this.$inertia.form({
                _method: "PUT",
                tarif_nilai_tutam: this.$page.props.setting.tarif_nilai_tutam,
            }),
        };
    },
    methods: {
        updateSettingTarifNilaiTutam() {
            this.form.post(route("setting.tarifnilaitutam.save"), {
                errorBag: "updateSettingTarifNilaiTutam",
                preserveScroll: true,
                // onSuccess: () => (this.clearPhotoFileInput()),
            });
        },
    },
});
</script>
